<article>
	<div>{{message()}}</div>
</article>
